// 接送机包车相关API
import request from '../utils/request';
import { createNonceStr, md5, getLocationSearch } from '../utils/utils';

// API路径定义
export const orderSelectApi = '/api/fly/order/select'; // 抢单大厅列表
export const orderRecordApi = '/api/fly/order/record'; // 接单记录
export const orderGrabApi = '/api/fly/order/grab'; // 抢单接口
export const orderCompleteApi = '/api/fly/order/complete'; // 完成订单
export const orderUpdateApi = '/api/fly/order/update'; // 更新订单状态
export const orderTodayApi = '/api/fly/order/today'; // 今日数据

/**
 * 获取请求签名参数
 * @returns {Object} 包含签名的请求参数
 */
export function getSignParams() {
  let token = getLocationSearch().token|| localStorage.getItem("userToken") || "";
  let appKey = "app_h5";
  let secret = "11dc72cf-88b0-46cd-91d7-b1a77fd69ee1";
  let timestamp = new Date().getTime();
  let random = createNonceStr();
  let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}token${token}`;
  let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
  
  return {
    appKey: appKey,
    timestamp: timestamp,
    random: random,
    token: token,
    sign: sign
  };
}

/**
 * 获取抢单大厅列表
 * @param {Object} params - 请求参数
 * @param {number} params.orderStatus - 订单状态 1-呼叫中
 * @param {number} params.pageNo - 页码
 * @param {number} params.pageSize - 每页数量
 * @returns {Promise}
 */
export function getOrderList(params) {
    
    const signParams = getSignParams();
    const token = signParams.token;
    return request.post(orderSelectApi, { ...params, token }, signParams);
}

/**
 * 获取接单记录
 * @param {Object} params - 请求参数
 * @param {number} params.pageNo - 页码
 * @param {number} params.pageSize - 每页数量
 * @returns {Promise}
 */
export function getOrderRecord(params) {
  const signParams = getSignParams();
  const token = signParams.token;
  
  return request.post(orderRecordApi, { ...params, token }, signParams);
}


/**
 * 抢单
 * @param {string} orderId - 订单ID
 * @returns {Promise}
 */
export function grabOrder(orderId) {
  const signParams = getSignParams();
  const token = signParams.token;
  
  return request.post(orderGrabApi, { orderId, orderStatus: "2", token }, signParams);
}

/**
 * 完成订单
 * @param {string} orderId - 订单ID
 * @returns {Promise}
 */
export function completeOrder(orderId) {
  const signParams = getSignParams();
  const token = signParams.token;
  
  return request.post(orderCompleteApi, { orderId, token }, signParams);
}

/**
 * 更新订单状态
 * @param {string} orderId - 订单ID
 * @param {string} orderStatus - 订单状态：2-接驾中, 3-司机到达上车点, 4-乘客上车, 5-已完成
 * @returns {Promise}
 */
export function updateOrderStatus(orderId, orderStatus) {
  const signParams = getSignParams();
  const token = signParams.token;
  
  return request.post(orderUpdateApi, { orderId, orderStatus, token }, signParams);
}

/**
 * 获取今日数据
 * @returns {Promise} 返回今日完单、今日收入、待处理订单数据
 */
export function getTodayData() {
  const signParams = getSignParams();
  const token = signParams.token;
  
  return request.get(orderTodayApi, { token }, signParams);
}
